@if (open) {
  <div class="fixed inset-0 z-[10040] bg-black/70 backdrop-blur-sm"></div>
  <section class="fixed inset-0 z-[10041] flex items-center justify-center p-4">
    <div
      class="w-full max-w-2xl overflow-hidden rounded-2xl border border-[#32455d] bg-[#0b131f] shadow-2xl"
    >
      <div class="flex items-center justify-between border-b border-[#2b3a4f] px-6 py-5">
        <div class="flex items-center gap-3">
          <span class="material-symbols-outlined text-[22px] text-[#2e9bff]">category</span>
          <h3 class="m-0 text-4xl font-bold text-[#eaf3ff]">{{ title }}</h3>
        </div>
        <button
          type="button"
          (click)="close.emit()"
          class="rounded-lg p-2 text-[#9ab0ca] transition hover:bg-[#1b2a3b] hover:text-[#eaf3ff]"
        >
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <form class="space-y-5 px-6 py-6" [formGroup]="form">
        <div>
          <label
            class="mb-1 block text-[0.68rem] font-bold uppercase tracking-[0.08em] text-[#8ea1bb]"
            >Category Name</label
          >
          <input
            type="text"
            formControlName="name"
            placeholder="e.g. Software Subscriptions"
            class="h-10 w-full rounded-lg border border-[#3b4b61] bg-[#1a2433] px-3 text-sm text-[#e8f0fc] placeholder:text-[#6f8096] outline-none focus:border-[#4d6f97]"
          />
        </div>

        <div>
          <label
            class="mb-1 block text-[0.68rem] font-bold uppercase tracking-[0.08em] text-[#8ea1bb]"
            >Type</label
          >
          <select
            formControlName="type"
            class="h-10 w-full rounded-lg border border-[#3b4b61] bg-[#1a2433] px-3 text-sm text-[#e8f0fc] outline-none focus:border-[#4d6f97]"
          >
            <option value="expense">Expense</option>
            <option value="income">Income</option>
          </select>
        </div>

        <div
          class="flex items-center justify-between rounded-xl border border-[#2e4159] bg-[#1b2533] p-4"
        >
          <div>
            <p class="m-0 text-[1.6rem] font-semibold text-[#e6eef9]">Set as Default</p>
            <p class="m-0 text-sm text-[#8ea1bb]">
              Apply this category to new transactions automatically
            </p>
          </div>
          <button
            type="button"
            (click)="form.patchValue({ setAsDefault: !form.value.setAsDefault })"
            class="relative h-7 w-14 rounded-full transition"
            [class]="form.value.setAsDefault ? 'bg-[#2e9bff]' : 'bg-[#2c3a4f]'"
          >
            <span
              class="absolute top-1 h-5 w-5 rounded-full bg-white transition"
              [class]="form.value.setAsDefault ? 'right-1' : 'left-1'"
            ></span>
          </button>
        </div>

        @if (errorMessage) {
          <p
            class="rounded-lg border border-[#7a3345] bg-[#26131a] px-3 py-2 text-sm text-[#ff9ab2]"
          >
            {{ errorMessage }}
          </p>
        }
      </form>

      <div class="flex justify-end gap-4 border-t border-[#2b3a4f] bg-[#111b2a] px-6 py-4">
        <button
          type="button"
          (click)="close.emit()"
          class="text-sm font-bold uppercase tracking-wide text-[#95a8bf] transition hover:text-[#eaf3ff]"
        >
          Cancel
        </button>
        <button
          type="button"
          (click)="save.emit()"
          [disabled]="saving"
          class="rounded-lg bg-[#2583ea] px-6 py-2.5 text-sm font-bold uppercase tracking-wide text-white transition hover:bg-[#1f75d1] disabled:cursor-not-allowed disabled:opacity-60"
        >
          {{ saving ? 'Saving...' : submitLabel }}
        </button>
      </div>
    </div>
  </section>
}
